(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/single-rows/betslip-footer-singlerows.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/single-rows/betslip-footer-singlerows.js'); "use strict";

(function (Backbone, _, svs) {
  'use strict';

  svs.tipset.views.BetslipFooterSinglerows = Marionette.View.extend({
    modelEvents: {
      change: 'render'
    },
    template: function template(data) {
      return svs.tipset.templates.betslip_footer_singlerows(data);
    },
    className: 'betslip-footer-singlerows',
    initialize: function initialize() {
      this.$el.addClass("betslip-footer-".concat(svs.tipset.models.gameDefinitions.get('htmlClass')));
    },
    change: function change() {
      this.render();
    },
    onDestroy: function onDestroy() {
      this.undelegateEvents();
      this.stopListening();

      if (svs.components.marketplace && svs.components.marketplace.accountSelector && svs.components.marketplace.accountSelector.helpers) {
        svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.marketplaceTag);
      }
    },
    marketplaceTag: function marketplaceTag(_ref) {
      var currentAccount = _ref.currentAccount;

      if (currentAccount) {
        svs.tipset.views.betslip.showBetslipTag(currentAccount.name);
      } else {
        svs.tipset.views.betslip.hideBetslipTag();
      }
    },
    onRender: function onRender() {
      var marketplace = svs.components.marketplace;

      if (window.location.href.indexOf('tipssm') > -1) {
        svs.tipset.views.betslip.showBetslipTag('Tips-SM');
        $('.betslip-footer-tag').addClass("betslip-footer-tag-".concat(svs.tipset.models.gameDefinitions.get('htmlClass')));
      } else if (marketplace && marketplace.accountSelector) {
        var account = marketplace.accountSelector.helpers.getCurrentAccount();

        if (account) {
          svs.tipset.views.betslip.showBetslipTag(marketplace.accountSelector.helpers.getCurrentAccount().name);
        } else if (svs.components.marketplace.accountSelector.helpers) {
          svs.components.marketplace.accountSelector.helpers.observer.subscribe(this.marketplaceTag);
          svs.tipset.views.betslip.hideBetslipTag();
        } else {
          svs.tipset.views.betslip.hideBetslipTag();
        }
      } else {
        svs.tipset.views.betslip.hideBetslipTag();
      }
    }
  });
})(Backbone, _, svs);
 })(window);